"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostCheckDiscountCode = void 0;
const Base_1 = require("./Base");
exports.PostCheckDiscountCode = {
    url: Base_1.URL_BASE + "/check",
    method: "POST",
    secure: false
};
//# sourceMappingURL=PostCheckDiscountCode.js.map